module.exports = __webpack_public_path__ + "img/gear-solid.044a3b70.svg";